module.exports = __webpack_public_path__ + "media/images/flags/1x1/tjk-2cd508c38299564caff5488051d8b096.svg";